import { render } from "./ProductTable.vue?vue&type=template&id=18174306&scoped=true&ts=true"
import script from "./ProductTable.vue?vue&type=script&lang=ts"
export * from "./ProductTable.vue?vue&type=script&lang=ts"

import "./ProductTable.vue?vue&type=style&index=0&id=18174306&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18174306"]])

export default __exports__